import type { Instance } from 'mobx-state-tree'
import { CreatorModelBase } from './CreatorModel.base'

/* The TypeScript type of an instance of CreatorModel */
export interface CreatorModelType extends Instance<typeof CreatorModel.Type> {}

/* A graphql query fragment builders for CreatorModel */
export {
  CreatorModelSelector,
  creatorModelPrimitives,
  selectFromCreator
} from './CreatorModel.base'

/**
 * CreatorModel
 */
export const CreatorModel = CreatorModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
